var store = require('../stores/store');

module.exports = {
    isAuthenticated: function() {
        return store.state.token ? true : false;
    },

    getToken: function() {
        if (this.isMasqueraded()) {
            return this.getMasqueradedToken();
        }

        return store.state.token;
    },
    
    login: function(profile, remember) {
        // remember for 90 days if wanted
        var options = (remember === true) ? { expires: 60*60*24*90 } : {};
    },

    logout: function() {
        Cookies.expire('masqueraded'); // to be sure        
        localStorage.removeItem('token');

        window.Intercom('shutdown');
    },

    masquerade: function(profile) {
        Cookies.set('masqueraded', profile.token);

        window.location = '/app/dashboard';
    },

    isMasqueraded: function() {
        return Cookies.get('masqueraded') ? true : false;
    },

    getMasqueradedToken: function() {
        return Cookies.get('masqueraded');
    },

    unmask: function() {
        Cookies.expire('masqueraded');

        window.location = '/app/dashboard';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/services/auth.js